import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const deleteBlockConfModalSelector = createSelector(modalsSelector, (modals) => modals.deleteBlockConf);

export default deleteBlockConfModalSelector;
